import taxExempt from './taxExempt';

const partnerProfile = {}

partnerProfile.taxExempt = taxExempt;

export default partnerProfile
